import React from "react";
import "./CharacterCard.css";

const CharacterCard = props => (
  <div className="card">
    <div className="img-container">
      <a onClick={() => props.selectCharacter(props.id)}>
        <img alt={props.id} src={props.image} />
      </a>
    </div>
  </div>
);

export default CharacterCard;



// WEBPACK FOOTER //
// ./src/components/CharacterCard/CharacterCard.js